<ng-template let-item #track>
  <mwo-track [isCurrent]="item.current" [item]="item" [mode]="'mini'"></mwo-track>
</ng-template>

<div class="mini-player-container" #miniPlayerContainer [@slideInOut]="animationState">
  <div class="drag-down-container" (swipedown)="destroy()">
    <svg class="drag-down" (click)="destroy()" width="28px" height="9px" viewBox="0 0 28 9" version="1.1"
         xmlns="http://www.w3.org/2000/svg">
      <title>Drag Down</title>
      <desc>Created with Sketch.</desc>
      <g id="UI" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="04-Player" transform="translate(-498.000000, -37.000000)" fill="#E7E7E7">
          <g id="Drag-Down" transform="translate(498.618590, 37.000000)">
            <path d="M2.51785892,0.144356204 L13.377,4.753 L24.067821,0.216185114 C24.9389426,-0.153584062 25.9387266,0.211408503 26.3733475,1.03250966 L26.4404324,1.1735353 C26.8333744,2.0992488 26.4010737,3.15470605 25.4809381,3.54528042 L25.4809381,3.54528042 L14.1650244,8.34860081 C13.750896,8.5243879 13.3076895,8.53411727 12.9099502,8.40772759 C12.7459259,8.3880604 12.5811082,8.34488002 12.4206555,8.2767719 L1.1047418,3.47345151 C0.184606229,3.08287714 -0.24769454,2.02741989 0.14524753,1.10170639 C0.535469047,0.182402105 1.59834169,-0.245955704 2.51785892,0.144356204 Z" id="Combined-Shape"></path>
          </g>
        </g>
      </g>
    </svg>
  </div>
  <div class="player-wrapper">
    <mwo-player [playerClass]="'mini'" style="width: 100%;"></mwo-player>
  </div>

  <mwo-smart-grid [list]="tracks$" [mode]="'vertical'" [itemTpl]="track" [fullPage]="false" [mini]="true">
    <h2 header>{{ 'player.mini.playlist' | translate }}</h2>
  </mwo-smart-grid>
</div>
